import Highway from '@dogstudio/highway'
import Loader from '../util/Loader'
import gsap from 'gsap'
import App from '../App';

export default class Fade extends Highway.Transition {
  getElems() {
    this.transition = document.body.querySelector('.transition')
  }

  in({ from, to, done }) {
    from.remove()

    this.getElems()
    Loader.load(to).then(() => {
      this.startSmoothScroll()
      this.hideLoader(to)

      done()
    })
  }

  out({ from, done }) {
    this.getElems()
    this.stopSmoothScroll()
    this.showLoader(from).then(done)
  }

  hideLoader() {
    gsap.to(this.transition, {
      y: '100vh',
      duration: 1,
      ease: 'power3.inOut',
      onComplete: () => {
        gsap.set(this.transition, {
          y: 0,
          scaleY: 0
        })
      }
    })
  }

  showLoader() {
    return new Promise((resolve) => {
      gsap.to(this.transition, {
        scaleY: 2,
        duration: 1.1,
        ease: 'power3.inOut',
        onComplete: resolve
      })
    })
  }

  startSmoothScroll() {
    if (!App.smoothScroll) return

    if (App.isMobile) {
      window.scrollTo(0, 0)
      App.smoothScroll.init()
    } else {
      App.smoothScroll.setScroll(0, 0)
      App.smoothScroll.update()
      App.smoothScroll.scroll.scrollbarThumb.style.height = `${window.innerHeight * window.innerHeight / (App.smoothScroll.scroll.instance.limit + window.innerHeight)}px`
      App.smoothScroll.scroll.scrollBarLimit = window.innerHeight - App.smoothScroll.scroll.scrollbarThumb.getBoundingClientRect().height
      App.smoothScroll.scroll.startScrolling()
      App.smoothScroll.start()
    }
  }

  stopSmoothScroll() {
    if (!App.smoothScroll) return

    if (App.isMobile) App.smoothScroll.destroy()
    else {
      App.smoothScroll.scroll.stopScrolling()
      App.smoothScroll.stop()
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/transitions/Fade.js